import * as yup from 'yup';

export const inviteHelpersValidation = yup.object({
  customMessageInviteHelpersRequest: yup
    .string()
    .required('Please set request helpers')
    .min(20, 'Should contain at least 20 char-s')
    .max(1000, 'Should contain less then 1000 char-s')
});
